import { component } from 'picoapp'

export default component((node) => {
    console.log('oof')
})